export default __webpack_public_path__ + "static/media/slider5.8c24b08f.gif";